var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKarmaStarColored = function SvgKarmaStarColored(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.682768 8.99864C-0.220642 8.67341 -0.232904 7.38056 0.677991 7.07693C3.69916 6.06987 6.06987 3.69916 7.07693 0.677991C7.38056 -0.232904 8.67341 -0.220642 8.99864 0.682768C10.0474 3.59614 12.4039 5.95255 15.3172 7.00136C16.2206 7.32659 16.2329 8.61944 15.322 8.92307C12.3008 9.93013 9.93013 12.3008 8.92307 15.322C8.61944 16.2329 7.32659 16.2206 7.00136 15.3172C5.95255 12.4039 3.59614 10.0474 0.682768 8.99864Z",
    fill: "#D61F7B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKarmaStarColored);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/karma-star-colored.865a36d1b54869b1eac695d1ca972f2e.svg";